import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService, ProfileService, StoreService } from '../../core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

const STORAGE_KEY = 'CLIENTS_LIST_GENERAL_FILTER';

@Component({
  selector: 'lms-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit, OnDestroy {
  public listId = 'CLIENTS_LIST';
  public toolbarConfig: any;
  public listOptions: any;
  public listSubscription: Subscription;
  public tableDataSource;
  public user;
  public myClientsFilterEnabled = false;
  public myClientsOptionSelected: string;
  public myClientsFilterOptions: any[];
  private foundDataSource = false;

  constructor(
    public breadcrumb: BreadcrumbService,
    public titleService: Title,
    public translate: TranslateService,
    public profileService: ProfileService
  ) {
    this.profileService.getLoggedUser$().subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit() {
    this.myClientsFilterEnabled = this.profileService.canExecute('clients.filters.general');
    this.myClientsOptionSelected = this.getStorageFilter(this.user.role);
    this.listOptions = this.myClientsOptionSelected === 'myClients' ? { filters: { agentIds: this.user.id } } : {};
    this.myClientsFilterOptions = [
      { key: 'myClients', value: this.translate.instant('clients.myClients') },
      { key: 'all', value: this.translate.instant('properties.every') }
    ];
    this.toolbarConfig = {
      list: {
        listId: this.listId,
        download: true,
        filterRow: true,
        columnChooser: this.profileService.canExecute('clients.column-chooser'),
        skeletor: true
      }
    };
    this.listSubscription = StoreService.get(this.listId).subscribe((value) => {
      this.tableDataSource = value;
      if (this.tableDataSource && !this.foundDataSource) {
        this.foundDataSource = true;
        this.onSelectorChange(this.myClientsOptionSelected);
      }
    });
    this.titleService.setTitle(
      this.translate.instant('pageTitle.clients') + ' - ' + this.translate.instant('pageTitle.gamelearn')
    );
  }

  ngOnDestroy(): void {
    this.listSubscription.unsubscribe();
  }

  onSelectorChange(value) {
    const filters = { ...this.tableDataSource.filters };
    if (value === 'myClients') {
      filters.agentIds = this.user.id;
    } else {
      delete filters.agentIds;
    }
    this.setStorageFilter(this.user.role, value);
    this.tableDataSource.refreshData({ filters, page: 1 });
    StoreService.update(this.listId, this.tableDataSource);
  }

  setStorageFilter(role: string, value: string) {
    localStorage.setItem(`${STORAGE_KEY}_${role}`, value);
  }

  getStorageFilter(role: string) {
    const storageFilter = localStorage.getItem(`${STORAGE_KEY}_${role}`);
    if (storageFilter) {
      return storageFilter;
    }
    return this.myClientsFilterEnabled ? 'myClients' : 'all';
  }
}
